import React from 'react';
import { EventWidgetDetailV2 } from '../../../../../../types/widget';
import EventWidgetSwipeLayout from './EventWidgetSwipeLayout';
import Modal from '../../../../../../components/Modal';
import WidgetPreviewHeader from '../../../common/components/WidgetPreviewHeader';

interface EventWidgetPreviewModalProps {
  isOpen: boolean;
  detail: Partial<EventWidgetDetailV2>;
  onClose: () => void;
}
const EventWidgetPreviewModal = (props: EventWidgetPreviewModalProps) => {
  const { isOpen, detail, onClose } = props;

  const getLayoutView = (detail: Partial<EventWidgetDetailV2>): JSX.Element => {
    switch (detail.layoutType) {
      case 'swipe':
        return <EventWidgetSwipeLayout list={detail.widgetItemEvents} />;
      default:
        return <EventWidgetSwipeLayout list={detail.widgetItemEvents} />;
    }
  };

  return (
    <Modal
      title={'위젯 미리보기'}
      isOpen={isOpen}
      width={375}
      height={700}
      padding={'0px'}
      isFooter={true}
      okText="확인"
      onOk={onClose}
      onClose={onClose}
    >
      <WidgetPreviewHeader mainTitle={detail.mainTitle} subTitle={detail.subTitle} />
      {isOpen && getLayoutView(detail)}
    </Modal>
  );
};

export default EventWidgetPreviewModal;
